<template>
    <layout-modal ref="modal">
        <template #default>
            <div class="modal-inner-shadow modal-inner-shadow-top">
                <account-card
                    :name="user?.name ?? ''"
                    :store="user?.store ?? 'KADEWE'"
                    :type="user?.loyalty_status ?? 'member'"
                    class="max-w-full sm:max-w-95 mb-5"
                />

                <img
                    :alt="$t('portal.card.qr_code')"
                    :src="baseUrl + 'api/card/download/qr-code?card=' + user?.card_number"
                    class="my-4 max-w-44 h-auto mx-auto aspect-square"
                />

                <p class="text-sm my-0">
                    <span v-html="cardNumberFormated" />
                </p>

                <p class="text-sm mt-2">{{ $t("portal.card.valid_until") }}: {{ validUntilFormated }}</p>
            </div>
        </template>
    </layout-modal>
</template>

<script lang="ts" setup>
import type { KadeweUser } from "~/types";
import type { LayoutModal } from "#components";

const user = useSanctumUser<KadeweUser>();
const dayjs = useDayjs();
const baseUrl = useBaseUrl();
const modal = ref<typeof LayoutModal | null>(null);

const cardNumberFormated = computed(() => {
    return user.value?.card_number?.replace(/(.{4})/g, "$1&nbsp;").trim();
});

const validUntilFormated = computed(() => {
    if (!user.value?.current_card_valid_until) {
        return "";
    }

    return dayjs.utc(user.value.current_card_valid_until).format("MM / YYYY");
});

defineExpose({
    open: () => {
        modal.value?.open();
    },
});
</script>
